import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import {triggerSponsorshipAnalyticsEvent} from '../../utils/analytics-helpers';
import { isInteractiveKeyCode } from "../../utils/helpers";
import { appendCampaignDefaultToUrl } from "../../utils/app-settings";

class SponsorCta extends Component {
  constructor(props) {
    super(props);
  }

  handleKeyUp(e) {
    if(isInteractiveKeyCode(e)) {
      (this.props.changeView) ?
      this.props.changeView(e, this.props.identifier, this.props.descriptorIndex) :
      undefined;
      (this.props.fireAddToCart) ? 
      triggerSponsorshipAnalyticsEvent("addToCart.sponsorship",{
        productName: "Child Sponsorship",
        productId: this.props.identifier,
        price: 39,
        category: "Sponsorship",
        quantity: 1,
        metric1: 39*1
      }) :
      undefined;
    }
  }

  getCtaLink() {
    // When campaign is configured from the window object and there is no campaign querystring parameter then add the campaign parameter to the link
    return appendCampaignDefaultToUrl(this.props.urlLink);
  }

  render() {
    const classList = this.props.classList.join(' ');
    const urlLink = this.getCtaLink();
    return (<div className="child-tile-cta">
    <a 
      className={classList} 
      href={urlLink} 
      onClick={
        (e)=>{
          (this.props.changeView)? this.props.changeView(e, this.props.identifier, this.props.descriptorIndex): undefined;
          (this.props.fireAddToCart)?  triggerSponsorshipAnalyticsEvent("addToCart.sponsorship",{
            productName: "Child Sponsorship",
            productId: this.props.identifier,
            price: 39,
            category: "Sponsorship",
            quantity: 1,
            metric1: 39*1
          }): undefined;
        }
      }
      onKeyUp={(e) => this.handleKeyUp(e)}
      tabIndex="0"
      >
      {this.props.sponsorshipTileCtaText}
      <span className="angle-right">
        <FontAwesomeIcon icon={faAngleRight} />
      </span>
    </a>
  </div>);
  }
}

export default SponsorCta;
